import { baseURL } from "services/API";

/** Public Spaces PDFs must not get JWT — that triggers CORS preflight on DO. */
export const shouldAttachPdfAuth = (url) => {
	if (!url || typeof url !== "string") return false;
	if (/digitaloceanspaces\.com/i.test(url)) return false;
	if (url.includes("api.rentbeta.africa") || url.startsWith(baseURL)) return true;
	return false;
};

export const buildPdfFileSource = (url, token) => {
	if (!url) return null;
	if (!token || !shouldAttachPdfAuth(url)) return url;
	return {
		url,
		httpHeaders: { Authorization: `Bearer ${token}` },
	};
};
